module.exports = __webpack_public_path__ + "img/small_whale05.01c72329.jpg";